import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  getInsContacts,
  getUpdateErrors,
  addInsContact,
  getDefaultInsurersList,
  getDefaultInsurersListSelector,
  toggleInsContactsModal,
  getInsContactsStatus,
  addBrokerageInsurer,
  updateIsActiveStatus,
  updateAllIsActiveStatus,
} from "../store/brokerage";
import { getBrokerInformation } from "../store/broker";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import { Switch } from "@material-ui/core";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
} from "../store/brokerages";
import Select from "react-dropdown-select";

import { useNavigate } from "react-router-dom";
import Loader3Orange from "../general/Loader3Orange";
import { LoadingLine } from "../general/LoadingLine";

const BrokerageSuperAdminInsurers = (props) => {
  const dispatch = useDispatch();

  let history = useNavigate();
  const [selectedCode, setSelectedCode] = useState(null);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  const brokerages = useSelector(getBrokeragesList);

  useEffect(() => {
    dispatch(loadBrokerages());
    if (props.brokerageCode) {
      dispatch(getDefaultInsurersList(props.brokerageCode));
      setSelectedCode(props.brokerageCode);
    }
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.brokerageCode &&
      !selectedCode &&
      brokerages &&
      brokerages[0]?.code
    ) {
      setSelectedCode(brokerages[0]?.code);
      dispatch(getDefaultInsurersList(brokerages[0]?.code));
      setSelectedBrokerageName(brokerages[0].name);
    } else if (props.brokerageCode && brokerages) {
      for (let br of brokerages) {
        if (br.code == props.brokerageCode) {
          setSelectedBrokerageName(br.name);
          break;
        }
      }
    }
  }, [brokerages]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      history(
        "/quoteyadmin/insurervisibility?c=" + encodeURIComponent(value[0].code)
      );
      dispatch(getDefaultInsurersList(value[0]?.code));
      setSelectedCode(value[0]?.code);
      setSelectedBrokerageName(value[0]?.name);
    }
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
        }}
      >
        <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={selectedBrokerageName}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[]}
            options={brokerages}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div>
      </div>
      <InsurerContactsPane brokerageCode={selectedCode}></InsurerContactsPane>
    </div>
  );
};

const InsurerContactsPane = (props) => {
  const dispatch = useDispatch();
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const insContacts = useSelector(getDefaultInsurersListSelector);

  const isArray = insContacts?.map((t) => t.isInsurerActiveForBrokerage);
  const filteredArray = isArray?.filter(
    (value) => value !== null && value !== undefined
  );
  const isAllTrue = filteredArray?.every((value) => value === true);

  useEffect(() => {
    if (isAllTrue && insContacts?.length > 0) {
      setIsAllChecked(true);
    } else {
      setIsAllChecked(false);
    }
  }, [insContacts?.length > 0 && isAllTrue]);

  const handleToggleAllInsurers = (isChecked) => {
    const previousSwitchState = isAllChecked;
    const confirmationMessage = `Are you sure you want to ${
      isChecked ? "activate" : "deactivate"
    } all insurers?`;
    setTimeout(() => {
      setIsLoading(true);
      if (window.confirm(confirmationMessage)) {
        const data = {
          insurer_code: insContacts?.map((item) => item.code),
          isactive: isChecked,
          brokerage_code: props.brokerageCode,
        };
        dispatch(updateAllIsActiveStatus(data)).then(async () => {
          await dispatch(getDefaultInsurersList(props.brokerageCode));
          await setIsAllChecked(isChecked);
          await setIsLoading(false);
        });
      } else {
        setIsAllChecked(previousSwitchState);
        setIsLoading(false);
      }
    }, 1000);
  };

  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
      }}
    >
      <div>
        <div className="d-flex align-items-center">
          <h5
            className="px-2"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Select which insurers are available for the brokerages to use.
          </h5>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "40px",
            }}
          >
            {isLoading && (
              <LoadingLine
                type={"spokes"}
                color={theme.COLORS.primary_navyblue}
              ></LoadingLine>
            )}

            <Switch
              color="primary"
              checked={isAllChecked}
              onChange={(e) => {
                handleToggleAllInsurers(e.target.checked);
              }}
            />
            <span style={{ color: "#212529", fontWeight: "bold" }}>
              Make it all as Default
            </span>
          </div>
        </div>
      </div>

      <InsurerContactItems brokerageCode={props.brokerageCode} />
    </div>
  );
};

const InsurerContactItems = (props) => {
  const dispatch = useDispatch();
  let insContacts = useSelector(getDefaultInsurersListSelector);
  const [loadingStatus, setLoadingStatus] = useState(
    Array(insContacts?.length).fill(false)
  );

  const checkIfBrokerageInsurerIsActive = (item) => {
    if (item.isInsurerActiveForBrokerage) {
      return item.isInsurerActiveForBrokerage;
    } else return false;
  };

  const handleToggleActive = async (item, index) => {
    setLoadingStatus((prevLoadingStatus) => {
      const updatedStatus = [...prevLoadingStatus];
      updatedStatus[index] = true;
      return updatedStatus;
    });

    const data = {
      insurer_code: item.code,
      isactive: !checkIfBrokerageInsurerIsActive(item),
      brokerage_code: props.brokerageCode,
    };

    try {
      await dispatch(updateIsActiveStatus(data));
      await dispatch(getDefaultInsurersList(props.brokerageCode));
    } catch (error) {
      setLoadingStatus((prevLoadingStatus) => {
        const updatedStatus = [...prevLoadingStatus];
        updatedStatus[index] = false;
        return updatedStatus;
      });
      toast.success("error", {
        style: {
          backgroundColor: theme.COLORS.toast_red,
          color: theme.COLORS.white_Indo,
        },
      });
    } finally {
      setLoadingStatus((prevLoadingStatus) => {
        const updatedStatus = [...prevLoadingStatus];
        updatedStatus[index] = false;
        return updatedStatus;
      });
    }
  };

  return (
    <div
      className="m-4"
      style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }}
    >
      <table className="table table-sm">
        <thead>
          <tr>
            <th scope="col">Insurer</th>
            <th scope="col">Active</th>
          </tr>
        </thead>
        {insContacts?.length === 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginLeft: "17vh",
              alignItems: "center",
              height: "10vh",
              // Adjust the height as needed
            }}
          >
            <LoadingLine
              type={"balls"}
              width={"5rem"}
              color={theme.COLORS.secondary_skyblue}
            ></LoadingLine>
          </div>
        )}

        <tbody>
          {insContacts ? (
            insContacts.map((item, index) => {
              return (
                <Fragment key={index}>
                  <tr scope="row" className="thead-light">
                    <td>{item.name}</td>
                    <td className="d-flex">
                      <Switch
                        checked={checkIfBrokerageInsurerIsActive(item)}
                        color="primary"
                        onChange={() => handleToggleActive(item, index)}
                      />
                      {loadingStatus?.[index] && (
                        <LoadingLine
                          type={"spokes"}
                          color={"#3f51b5"}
                          width={"15%"}
                        ></LoadingLine>
                      )}
                    </td>
                  </tr>
                </Fragment>
              );
            })
          ) : (
            <tr />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BrokerageSuperAdminInsurers;
